// Full-document render of the password-reset "done" view: PageSkeleton (the
// React document shell) wrapping the toppers account-shell layout (side nav +
// content title) around the confirmation copy. The template rendered
// two paragraphs and no heading; the paragraphs are server-localized props.
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetDoneDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            {props.paragraphs.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
            ))}
        </AccountShell>
    </PageSkeleton>
);
